import
  React, {
  useContext
} from 'react';

import {
  useHistory
} from 'react-router-dom';

import
  PropTypes
from 'prop-types';

import
  styled
from 'styled-components';

import {
  ColorCodes,
  ColorSvg,
  HContainer,
  HContainerV,
  Image,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  FeatureMenuLabels,
  FeatureToggles,
  Icons
} from '../../constants';

import {
  handleUtagLinkEvent,
  isFeatureEnabled,
  useRedirectHandler
} from 'helpers';

import {
  AppContext
} from 'context';

const Container = styled(HContainerV)`
  border-bottom: ${props => props.borderBottom};
`;

const OverLay = styled.div`
  position: relative;
  left: 0;
  right: 0;
  background: ${CustomColors.White};
  max-height: 65vh;
  overflow-y: auto;
`;

const SvgContainer = styled(VContainer)`
  border-left: ${props => props.borderLeft};
`;

const StickyContainer = styled(VContainer)`
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const Header = props => {

  const history = useHistory();
  const { config } = useContext(AppContext);
  const [ state, setState ] = React.useState({
    isMenuOpen: false
  });
  const redirectHandler = useRedirectHandler();

  let menuItems = props.menuItems;

  for (const featureMenuLabel of Object.keys(FeatureMenuLabels)) {

    if (!isFeatureEnabled(config, FeatureToggles[featureMenuLabel])) {
      menuItems = menuItems.filter(item => item?.label !== FeatureMenuLabels[featureMenuLabel]);
    }
  }

  const createMenuItems = () => {

    let menuItemsList = [];

    for (const item of menuItems) {

      if (!item || !item.label || !item.url) {
        continue;
      }

      menuItemsList.push (

        <HContainer
          key={`menu-item-${item.label}`}
          borderBottom={`solid 1px ${ColorCodes.Grey5}`}
          padding={'15px'}
          onClick={() => {

            setState(prevState => ({
              ...prevState,
              isMenuOpen: false
            }));

            if (props.externalLinks.length > 0 && props.externalLinks.includes(item.url)) {

              redirectHandler(
                history.location,
                `/redirect?targetUrl=${encodeURIComponent(item.url)}&isZeroRated=true`,
                true
              );
              return;
            }

            handleUtagLinkEvent({
              event_action: 'click',
              event_category: 'menu navigation',
              event_label: item.label
            });

            history.push({
              pathname: item.url,
              state: {
                item: item
              }
            });
          }}>

          <Text
            fontSize={'18px'}
            color={CustomColors.Grey11}
            flex={'1'} >

            {item.label}
          </Text>

          {item.description &&

            <Container
              backgroundColor={ColorCodes.Red1}
              padding={'4px 12px'} >

              <Text
                color={ColorCodes.White}
                fontSize={'12px'}
                fontFamily={'Roboto'} >

                {item.description}
              </Text>
            </Container>
          }

        </HContainer>
      );
    }

    return menuItemsList;
  };

  return (

    <StickyContainer
      width={'100%'}>

      <Container
        width={'100%'}
        height={'80px'}
        padding={'0 14px 0 15px'}
        borderBottom={`solid 1px ${ColorCodes.Grey5}`}
        backgroundColor={ColorCodes.White}
        boxSizing={'border-box'}>

          <Image
            src={Icons.ConnectU}
            width={'115px'}
            height={'28px'}
            onClick={() => {
              history.push('/home');
            }}/>

        <SvgContainer
          padding={'0 0 0 16px'}
          borderLeft={!state.isMenuOpen ? `1px solid ${CustomColors.Grey5}` : ''}
          margin={'0 0 0 auto'}
          onClick={() => {

            setState(prevState => ({
              ...prevState,
              isMenuOpen: !prevState.isMenuOpen
            }));
          }}>

          <ColorSvg
            src={Icons.Close}
            color={CustomColors.Grey11}
            width={'30px'}
            height={'30px'}
            display={!state.isMenuOpen ? 'none' : undefined}/>

          <ColorSvg
            src={Icons.HamburgerMenu}
            color={CustomColors.Grey11}
            width={'30px'}
            height={'30px'}
            display={state.isMenuOpen ? 'none' : undefined}/>
        </SvgContainer>

      </Container>

      { state.isMenuOpen &&

        <OverLay>
          { createMenuItems() }
        </OverLay>
      }

    </StickyContainer>
  );
};

Header.propTypes = {
  headerText: PropTypes.string,
  menuItems: PropTypes.array,
  externalLinks: PropTypes.array
};

Header.defaultProps = {
  headerText: 'connectU',
  menuItems: [],
  externalLinks: []
};
